<img *ngIf="imageTitle" src="{{imageTitle}}" alt="titulo" height="42" width="42" class="float-left mr-2">
<i *ngIf="faIcon" [class]="'fa fa-2x float-left mr-2 fa-' + faIcon"></i>
<h3 class="font-weight-light m-0" style="color: #424242; white-space: nowrap">{{pageTitle}}</h3>
<p
  style="font-family: 'Rationale', Arial, Helvetica, sans-serif; font-weight: bold; font-size: 1.1rem; color: #b71c1c; margin-bottom: 0; white-space: nowrap">
  {{pageSubtitle}} <span *ngIf="showChange" style="font-size: 10px"
    class="ml-2 badge badge-danger">{{pageChange}}</span>
</p>